import { connect } from 'react-redux'
import Resume from 'modules/Resume/index'
import selectors from 'modules/Onboarding/selectors'
import selectors1 from 'modules/Resume/selectors'
import {
  deleteFile,
  deleteEducation,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  getFunctionsList,
  getDesignationsList,
  getIndustryList,
  getListOfSkills,
  searchAPI
} from 'modules/Onboarding/actions'

import {
  getStudentData,
  updateStudentData,
  getCollege,
  getCities,
  getListOfAllCollegesCurCourse,
  getPromotion,
  getPendingData,
  getFrozenFields,
  getStudentResumeData,
  upsertStudentResume
} from 'modules/Resume/actions'

const mapStateToProps = state => ({
  studentData: selectors.getStudentResumeData(state),
  studentDetails: selectors.getStudentResumeData(state),
  instituteName: selectors.getCampuDetails(state),
  countryList: selectors.getCountryList(state),
  functionsList: selectors.getFunctionsList(state),
  degreeList: selectors.getDegreeList(state),
  stateList: selectors.getStateList(state),
  listOfSkills: selectors.getListOfSkills(state),
  CollegeList: selectors1.getListOfAllCollegesCurCourse(state),
  promotionData: selectors1.getPromotion(state),
  pendingData: state.resumeData?.pendingData,
  frozenFields: state.resumeData?.frozenFields,
})

const mapDispatchToProps = {
  getCollege,
  getStudentData,
  getPromotion,
  getPendingData,
  getFrozenFields,
  updateStudentData,
  deleteFile,
  deleteEducation,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  getCities,
  getFunctionsList,
  getDesignationsList,
  getIndustryList,
  getListOfSkills,
  getListOfAllCollegesCurCourse,
  searchAPI,
  getStudentResumeData,
  upsertStudentResume
}

export default connect(mapStateToProps, mapDispatchToProps)(Resume)
